import { FC, useEffect, useState, useRef } from 'react'
import styles from 'components/WebEv/PressWithQuote/PressWithQuote.module.scss'
import { Button } from 'components/WebEv/Buttons'
import { CompanyFunction, FinancialTimes, Forbes, GQ, MensHealth } from 'components/_const_assets/companyLogos'
import cx from 'classnames'
import { Slider2023 } from '../Slider2023'
import { Theme } from 'components/_utils/utilityTypes'

export const PressWithQuote: FC = () => {
	const [activeSlide, setActiveSlide] = useState(0)
	const activeTimeout = useRef<NodeJS.Timeout | null>(null)

	useEffect(() => {
		//Changes slides every 4 seconds
		clearTimeout(activeTimeout.current)
		activeTimeout.current = setTimeout(() => {
			setActiveSlide((prev) => (prev + 1) % slides.length)
		}, 4000)
	}, [activeSlide])

	return (
		<div className={`${styles.container}`}>
			<div className={styles.quote_container}>
				<h3 className={styles.quote}>“The Pod makes it feel like you’re participating in the future of sleep tech.”</h3>
			</div>
			<div className={styles.desktop_container}>
				<ul className={styles.desktop_list}>
					{slides.map((slide, index) => (
						<PressQuoteLogo
							key={slide.company}
							logo={slide.logo}
							quote={slide.quote}
							activeSlide={index == activeSlide}
							company={slide.company}
							color={'#000'}
							onClick={() => {
								setActiveSlide(index)
							}}
						/>
					))}
				</ul>
			</div>
			<div className={styles.mobile_container}>
				<Slider2023
					theme={Theme.LIGHT}
					settings={{ slidesToShow: 1, autoplay: true, autoplaySpeed: 4000, arrows: false, dots: false, adaptiveHeight: true }}
					beforeChange={(currentSlide, nextSlide) => setActiveSlide(nextSlide)}
				>
					{slides.map((slide, index) => (
						<MobileSlide
							key={slide.company}
							logo={slide.logo}
							quote={slide.quote}
							activeSlide={index == activeSlide}
							company={slide.company}
							color={'#000'}
						/>
					))}
				</Slider2023>
			</div>
		</div>
	)
}

interface PressQuoteProps {
	logo: CompanyFunction
	company: string
	quote: string
	activeSlide?: boolean
	onClick?: () => void
	color: string
}

const PressQuoteLogo: FC<PressQuoteProps> = (props) => {
	return (
		<li className={styles.logo_container}>
			<Button.Empty
				id={`button-for-${props.company}`}
				onClick={props.onClick}
				className={cx(styles.button, { [styles.button_active]: props.activeSlide })}
			>
				<div className={styles.logo}>{props.logo(props.color)}</div>
			</Button.Empty>
		</li>
	)
}

const MobileSlide: FC<PressQuoteProps> = (props) => {
	return (
		<div className={styles.mobile_slide}>
			<div className={styles.logo_container}>
				<div className={styles.logo}>{props.logo(props.color)}</div>
			</div>
			<p className={styles.quote}>{props.quote}</p>
		</div>
	)
}

const slides: any[] = [
	{
		logo: GQ,
		company: 'gq',
	},
	{
		logo: FinancialTimes,
		company: 'financial_times',
	},
	{
		logo: MensHealth,
		company: 'mens_health',
	},
	{
		logo: Forbes,
		company: 'forbes',
	},
]
